import { ADMIN_APP, CLIENT_APP } from '@shabic/constants';

export type AppType = typeof ADMIN_APP | typeof CLIENT_APP;
